// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// *************************************************************** shifts assignment *****************************************************************
const GET_ALL_SHIFT_USER_ASSIGNMENT_SUCCESS =
  "GET_ALL_SHIFT_USER_ASSIGNMENT_SUCCESS";
const INDEX_ASSIGNMENT_SALARY_SUCCESS = "INDEX_ASSIGNMENT_SALARY_SUCCESS";
// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// *************************************************************** shifts assignment *****************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @param {String} component
 * @return {{type: String, payload: Object}}
 * @private
 */
function _getSuccess(payload, component = "Data") {
  let shifts = [];
  let positions = [];
  if (component === "User") {
    shifts = payload.data.user.shifts;
    positions = payload.data.user.positions;
  } else {
    shifts = [];
    positions = [payload.data];
  }

  return {
    type: GET_ALL_SHIFT_USER_ASSIGNMENT_SUCCESS,
    payload: { shifts, positions },
  };
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptyShifts() {
  return _getSuccess({ data: { shifts: [] } });
}
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexSuccess(payload) {
  return {
    type: INDEX_ASSIGNMENT_SALARY_SUCCESS,
    payload: payload,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// *************************************************************** shifts assignment *****************************************************************

/**
 *
 * @param {String} component
 * @param {Number} id
 * @return {string}
 */
function getRoute(component = "User", id = 0) {
  let route = `/users/${id}/shifts`;
  if (component === "position") {
    route = `/positions/${id}/shifts`;
  }
  return route;
}

/**
 *
 * @param {String} component
 * @param {Number} user
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function index(
  component = "User",
  user,
  params = {},
  callback = () => {}
) {
  return (dispatch, gs, api) => {
    //if (app.can('ShiftAssignment@update')) {
    if (app.can("Shift@assignShift")) {
      let route = getRoute(component, user);

      api
        .get(route, { params })
        .then((res) => {
          dispatch(_getSuccess(res, component));
          callback(undefined, res);
        })
        .catch((err) => {
          callback(err);
        });
    }
  };
}

/**
 *
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function indexSalary(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
      api
        .get("/ta/shifts", { params })
        .then((res) => {
          dispatch(_indexSuccess(res));
          console.log("ecsevwsv",res);
          callback(undefined, res);
        })
        .catch((err) => {
          app.error(
            err,
            "routes.home.attendance.shift",
            "ثبت درخواست شکست خورد",
            app.translate("routes.home.attendance.shift.Indexing Shifts Failed")
          );
          callback(err);
        });
    
  };
}

/**
 *
 * @param {Object} [data={}]
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function store(data, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    //if (app.can('ShiftAssignment@update')) {
    if (app.can("Shift@assignShift")) {
      let loader = app.loading(
        app.translate("routes.home.attendance.shift.Shift Assignment")
      );
      api
        .post(`/ta/shifts/assignment`, { data: { data: data }, params })
        .then((res) => {
          dispatch(_getSuccess(res));
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.attendance.shift.Shift Assigned Successfully"
              )
            )
          );
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.attendance.shift",
              "خطا در ارسال اطلاعات",
              app.translate(
                "routes.home.attendance.shift.Shift Assignment Failed"
              )
            )
          );
          callback(err);
        });
    }
  };
}

/**
 *
 * @param {Number} shift
 * @param {Object} [data={}]
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function changeShift(shift, data, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    //if (app.can('ShiftAssignment@update')) {
    if (app.can("Shift@assignShift")) {
      api
        .put(`/ta/shifts/${shift}/positions`, { data: { shift: data }, params })
        .then((res) => {
          dispatch(_getSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          callback(err);
        });
    }
  };
}

/**
 *
 * @param {Object} [data={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function assignShift(data, callback = () => {}) {
  return (dispatch, gs, api) => {
    //if (app.can('ShiftAssignment@update')) {
    if (app.can("Shift@assignShift")) {
      let loader = app.loading(
        app.translate("routes.home.attendance.shift.Shift Assignment")
      );
      api
        .post(`/Salary/AssignPersonToPatternDetail`, { data: data })
        .then((res) => {
          loader.hide(() =>
            app.message(
              app.translate(
                "انتساب حقوق ودستمزد با موفقت انجام شد."
              )
            )
          );
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.attendance.shift",
              "انتساب شیفت شکست خورد",
              app.translate(
                "routes.home.attendance.shift.Check Shift Assignment Failed"
              )
            )
          );
          callback(err);
        });
    }
  };
}

/**
 *
 * @param {Object} [data={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function checkAssignShift(data, callback = () => {}) {
  return (dispatch, gs, api) => {
    //if (app.can('ShiftAssignment@update')) {
    if (app.can("Shift@assignShift")) {
      let loader = app.loading(
        app.translate("routes.home.attendance.shift.Check Shift Assignment")
      );
      api
        .post(`/ta/shifts/check_assign`, { data: data })
        .then((res) => {
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.attendance.shift.Check Shift Assignment successfully"
              )
            )
          );
          dispatch(_getSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.attendance.shift",
              "خطا در ارسال اطلاعات",
              app.translate(
                "routes.home.attendance.shift.Check Shift Assignment Failed"
              )
            )
          );
          callback(err);
        });
    }
  };
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(
  state = {
    userShifts: [],
    positionShifts: [],
    shift: {},
  },
  action
) {
  let _meta;
  switch (action.type) {
    case GET_ALL_SHIFT_USER_ASSIGNMENT_SUCCESS:
      return Object.assign({}, state, {
        userShifts: action.payload.shifts,
        positionShifts: action.payload.positions,
      });
    case INDEX_ASSIGNMENT_SALARY_SUCCESS:
      console.log("action.payloadsvsd",action.payload);
      _meta = action.payload.meta;
      return Object.assign({}, state, {
        shifts: action.payload.data.shifts,
        pagination: _meta
          ? app.pagination(_meta.currentPage + 1, _meta.total, _meta.limit)
          : {},
      });
    default:
      return state;
  }
}
